import { view_car_details } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";

export const GetNearCarDetails = {
  mixins: [],
  data() {
    return {
      GetNearCarDetails: [],
      overlay: false,
    };
  },
  methods: {
    async GetNearCarDetailsMethod(UserId, User_name) {
      try {
        this.overlay = true;
        var inputParams = {
          user_id: UserId,
        };

        let result = await API.graphql(
          graphqlOperation(view_car_details, {
            input: inputParams,
          })
        );
        let CarDetails = JSON.parse(result.data.view_car_details);
        this.GetNearCarDetails = JSON.parse(result.data.view_car_details).data;
        this.overlay = false;
        if (CarDetails.status == 200) {
          // this.StoreObj = this.GetNearCarDetails;
          // this.StoreObj.action = "LandingView";
          this.ManyCarsArray = this.GetNearCarDetails;
          this.UserName = User_name;
          this.AnyCarDetailsDialog = true;
          // this.AllCarDetails = true;
        }
      } catch (error) {
        console.log("Check error", error);
        this.overlay = false;
      }
    },
  },
};
